import React from "react";
import { Link } from "@mui/material";

import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";

const SocialNetworkIcons = () => {
  return (
    <>
      <Link
        href={process.env.REACT_APP_INSTAGRAM_URL}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <InstagramIcon sx={{ color: "#c1c1c1" }} />
      </Link>
      <Link
        href={process.env.REACT_APP_FACEBOOK_URL}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <FacebookIcon
          sx={{
            ml: "1.25rem",
            mr: "1.25rem",
            color: "#c1c1c1",
          }}
        />
      </Link>
      <Link
        href={process.env.REACT_APP_X_URL}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <XIcon sx={{ color: "#c1c1c1" }} />
      </Link>
  </>
  );
};

export default SocialNetworkIcons;
